import React, { useState, useEffect } from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import RootLayout from './RootLayout';
import getClient from '../network/client';
import Loading from '../components/Loading';
import { RootContextProvider } from './RootLayout/context';

const App = () => {
  const [client, setClient] = useState(null);
  const [isLoading, setLoading] = useState(true);

  const resetClient = (token) => {
    getClient(token)
      .then((data) => {
        setClient(data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    resetClient();
  }, []);

  if (isLoading) return <Loading />;

  return (
    <ApolloProvider client={client}>
      <RootContextProvider resetClient={resetClient}>
        <RootLayout />
      </RootContextProvider>
    </ApolloProvider>
  );
};

export default App;
